import { Component, Input, OnDestroy } from '@angular/core';
import { Subscription, TeardownLogic } from 'rxjs';

import { UserInfo, UserRole } from 'app/core/services/user/user';
import { UserService } from 'app/core/services';


@Component({
    selector: 'app-multi-role-selector',
    templateUrl: './multi-role-selector.component.html',
})
export class MultiRoleSelectorComponent implements OnDestroy {
    private _subrelease = new Subscription();
    get subrelease(): TeardownLogic {
        return this._subrelease;
    }
    set subrelease(sub: TeardownLogic) {
        this._subrelease.add(sub);
    }
    
    user: UserInfo | null = null;
    currentRoleInfo?: UserRole | null = null;

    @Input('isCaption') isCaption: boolean = false;

    constructor(private userService: UserService) {
        const self = this;
        self.user = self.userService.User;
        self.currentRoleInfo = self.userService.User?.CurrentRoleInfo;

        self.subrelease = self.userService.UserSubject.subscribe((_user) => {
            self.user = _user;
            self.currentRoleInfo = _user?.CurrentRoleInfo;
        });
    }
    
    ngOnDestroy() {
        this._subrelease?.unsubscribe();
    }

    updateUser(newRoleInfo: UserRole) {
        this.userService.SetUserCurrentRole(newRoleInfo, null, this.currentRoleInfo!);
    }

    compareFn(obj1: any, obj2: any) {
        return Object.entries(obj1).toString() === Object.entries(obj2).toString()
    }
}
